/**
 * The collection-status marker on a Billing row.
 *
 * Colour carries health, the icon carries the state — so the three green
 * states (authorized, processing, paid) stay readable for anyone who can't
 * separate them by hue, and nothing is drawn at all for a merchant who was
 * never set up, where a marker would wrongly imply a problem.
 */

const PATHS = {
  // Waiting on the merchant/their bank.
  hourglass: (
    <>
      <path d="M6 2h12M6 22h12" />
      <path d="M8 2v4a4 4 0 0 0 4 4 4 4 0 0 0 4-4V2" />
      <path d="M8 22v-4a4 4 0 0 1 4-4 4 4 0 0 1 4 4v4" />
    </>
  ),
  // Bank account attached and the mandate signed — nothing blocks a debit.
  // Deliberately not a clock: the hourglass above already means "waiting", and
  // two time metaphors for opposite states are separable only by hue.
  bank: (
    <>
      <path d="M3 9.5L12 4l9 5.5" />
      <path d="M6 11v7M12 11v7M18 11v7" />
      <path d="M3.5 21h17" />
    </>
  ),
  // In flight at the bank.
  processing: (
    <>
      <path d="M21 12a9 9 0 1 1-3.5-7.1" />
      <path d="M21 3v6h-6" />
    </>
  ),
  check: <path d="M4 12.5l5 5L20 6.5" />,
  alert: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7.5v5.5M12 16.2v.3" />
    </>
  ),
};

// `showTitle={false}` drops the hover tooltip while keeping role/aria-label, so
// a dense table can carry these markers without every cell popping a bubble.
const BillingStatusIcon = ({ state, size = 18, showTitle = true }) => {
  if (!state || !state.icon) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={state.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={state.label}
    >
      {showTitle && <title>{state.label}</title>}
      {PATHS[state.icon]}
    </svg>
  );
};

export default BillingStatusIcon;
